import SmoothScrollIntoView from '../__frontend/smoothScrollIntoView.js';
import delayedScripts from '../__frontend/delayedScripts.js';

// GLOBAL APP CONTROLLER
const controller = {
	init() {
		document.querySelector('html').classList.remove('no-js');
		SmoothScrollIntoView();
		delayedScripts();
	},
	loaded() {
		// Only add functions here that are okay to run after the entire page has loaded (include media/images).
	},
	resized() {},
	scrolled() {},
	keyDown() {},
	mouseUp() {},
};
export default controller;
